import { getItemModelCatalogId, getItemModelSellerId } from '@/redux/modules/item/summary/itemSummary.selectors';
import {
    LotRecommendationTrigger,
    LotRecommendationType,
    useTrackLotRecommendationClickedAnalytics,
} from '@/utils/amplitude/analytics/item/trackLotRecommendationClicked.analytics';
import { useAppSelector } from '@/redux/hooks';
import { useCallback } from 'react';

type UseRecommendationTrackingProps = {
    /** Whether the recommendation position uses 0-based indexing. Defaults to false (1-based). */
    isZeroBasedPosition?: boolean;
    itemId: number;
    recommendationPosition: number;
    recommendationType: LotRecommendationType;
};

export const useRecommendationTracking = ({
    isZeroBasedPosition = false,
    itemId,
    recommendationPosition,
    recommendationType,
}: UseRecommendationTrackingProps) => {
    const trackLotRecommendationClicked = useTrackLotRecommendationClickedAnalytics();
    const catalogId = useAppSelector((state) => getItemModelCatalogId(state, itemId));
    const houseId = useAppSelector((state) => getItemModelSellerId(state, itemId));

    return useCallback(
        (trigger: LotRecommendationTrigger) => {
            if (recommendationType) {
                trackLotRecommendationClicked({
                    catalogId,
                    houseId,
                    itemId,
                    lotClickPosition: isZeroBasedPosition ? recommendationPosition + 1 : recommendationPosition,
                    recommendationName: recommendationType,
                    trigger,
                });
            }
        },
        [
            catalogId,
            houseId,
            isZeroBasedPosition,
            itemId,
            recommendationPosition,
            recommendationType,
            trackLotRecommendationClicked,
        ]
    );
};
